"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "Carnet ATA",
  description: "Soluzioni strategiche per la mobilità internazionale dei dipendenti, gestione trasferimenti e conformità normativa globale.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_mobility_icon.png",
  isNew: false,
  link: "/CompanyServicesPage"
}, {
  title: "Certificati di Origine",
  description: "Consulenza specialistica per l'ottenimento di visti lavorativi, permessi di soggiorno e pratiche di cittadinanza complesse.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visa_immigration_icon.png",
  isNew: false,
  link: "/VisasAndImmigrationPage"
}, {
  title: "Documenti Doganali",
  description: "Supporto completo per percorsi accademici internazionali, visti studio e programmi di scambio per istituti d'eccellenza.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/education_global_icon.png",
  isNew: true,
  link: "/StudentsAndInstitutesPage"
}, {
  title: "Legalizzazioni Commerciali",
  description: "Assistenza completa per la legalizzazione di documenti commerciali internazionali.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_one.png",
  isNew: false,
  link: "#"
}, {
  title: "Assistenza Export UK",
  description: "Supporto specializzato per le operazioni di export verso il Regno Unito.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_two.png",
  isNew: false,
  link: "#"
}, {
  title: "Export per Fiere",
  description: "Gestione logistica e documentale per la partecipazione a fiere internazionali.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_three.png",
  isNew: false,
  link: "#"
}, {
  title: "Traduzioni Commerciali",
  description: "Servizio di traduzione professionale per contratti e materiale commerciale.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_four.png",
  isNew: false,
  link: "#"
}, {
  title: "Assistenza Importazione",
  description: "Consulenza e supporto per le pratiche di importazione merci.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_five.png",
  isNew: false,
  link: "#"
}, {
  title: "Supporto Documentale Internazionale",
  description: "Gestione e revisione di documenti internazionali per compliance e operatività.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/service_placeholder_six.png",
  isNew: false,
  link: "#"
}];
export default function SolutionsBuiltForYou() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223974" id="servicesgrid" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block text-secondary font-default font-semibold tracking-widest uppercase text-sm mb-4">
            Eccellenza nella Mobilità Globale
          </span>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-primary leading-tight">
            Servizi Corporate Premium
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => <Card key={i} data-index={i} className="bg-white rounded-md shadow-md border-2 border-muted h-full flex flex-col transition-shadow duration-300 hover:shadow-xl">
              <CardHeader className="p-8 pb-4 items-start">
                <img src={solution.image} alt={`${solution.title} icon`} className="w-16 h-16 object-contain mb-6" loading="lazy" data-wvc-srcset={`${solution.image}-wvc-srcset`} data-wvc-sizes={`${solution.image}-wvc-sizes`} />
                {solution.isNew && <Badge className="bg-secondary text-secondary-foreground hover:bg-secondary/90 mb-4 px-2 py-1 text-xs font-bold tracking-wide rounded-md">
                    NUOVO
                  </Badge>}
                <CardTitle className="font-default text-2xl text-primary mt-2">
                  {solution.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-8 pt-0 flex-grow">
                <CardDescription className="text-base text-muted-foreground font-default leading-relaxed">
                  {solution.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="p-8 pt-0 mt-auto border-t-0">
                <Link to={solution.link} className="group inline-flex items-center font-default font-medium text-primary hover:text-secondary transition-colors">
                  Scopri di più
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}